import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const CategorySkeleton = ({ showSidebar = true }) => {
  return (
    <div className="main-content-container categories-page">
      {/* Header centrato */}
      <div className="categories-header">
        <div className="skeleton-category-header skeleton-loader"></div>
        <div className="skeleton-category-subtitle skeleton-loader"></div>
      </div>
      
      {/* Grid delle categorie */}
      <div className="categories-grid">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="category-card">
            <div className="category-card-content">
              <div className="category-info">
                <div className="skeleton-category-title skeleton-loader"></div>
                <div className="category-subcategories">
                  <div className="subcategories-list">
                    <div className="skeleton-subcategory skeleton-loader"></div>
                    <div className="skeleton-subcategory skeleton-loader"></div>
                    <div className="skeleton-subcategory skeleton-loader"></div>
                  </div>
                </div>
              </div>
              <div className="skeleton-expand-btn skeleton-loader"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategorySkeleton; 